module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_bztc@2x.9d4a9ebc.png";